export default "/dist/f563150df2486febb091a43a78afddad.png";